import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import type { CompoundEntityRef } from '@backstage/catalog-model';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { fetchDomainsForTenant } from '../catalog/hierarchy';

export function useDomainEntities(tenantRef: CompoundEntityRef | undefined) {
  const catalogApi = useApi(catalogApiRef);
  const tenantRefString = tenantRef ? stringifyEntityRef(tenantRef) : undefined;

  const { value, loading, error } = useAsync(async () => {
    return fetchDomainsForTenant(catalogApi, tenantRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogApi, tenantRefString]);

  return {
    items: value ?? [],
    loading,
    error,
  };
}
